export const teamsKeys = {
	teamsGroupedByDivision: (organizationUuid: string, teamLeagueUuid: string, serializedSearchParams: string) =>
		['TEAMS_GROUPED_BY_DIVISION', organizationUuid, teamLeagueUuid, serializedSearchParams] as const,
	teamsOptions: (organizationUuid: string, teamLeagueUuid: string, seasonUuid?: string) =>
		[`TEAMS_OPTIONS`, organizationUuid, teamLeagueUuid, seasonUuid] as const
};
